export default "assets/images/icons/cible-1a4510dc.svg";